import './ConfirmMetStatusModal.scss'

import React from 'react'
import { connectModal } from 'redux-modal'
import { Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectReferralName } from 'manager/selectors/referral_selectors'
import { setSelectedStatus } from 'manager/redux/referral_status'
import { AGENT_STATUS_SPOKE, AGENT_STATUS_MET } from 'common/constants'


const ConfirmMetStatusModal = ({ onConfirm, handleHide, show, name, setSelectedStatus }) => {

  const goToSpoke = () => {
    handleHide()
    setSelectedStatus(AGENT_STATUS_SPOKE)
  }

  const goToMetStatus = async () => {
    handleHide()
    setSelectedStatus(AGENT_STATUS_MET)
    onConfirm && onConfirm()
  }

  return (
    <Modal className="ConfirmMetStatusModal" show={show} style={{ paddingLeft: 0 }}>
      <Modal.Body>
        <div className="title">
          <span>Have you and {name} met?</span>
        </div>
        <div className="subtitle">
          <span>Last update, you said you met in person or virtually with {name}. Is this correct?</span>
        </div>
        <Button onClick={goToMetStatus} bsStyle="primary">
          Yes, we met
        </Button>
        <Button onClick={goToSpoke} bsStyle="primary">
          No, we have only spoken
        </Button>
      </Modal.Body>
    </Modal>
  )
}

const withModalHandlers = connectModal({ name: 'ConfirmMetStatusModal', destroyOnHide: true })

const withRedux = connect(
  createStructuredSelector({ name: selectReferralName }),
  { setSelectedStatus },
)

export default withModalHandlers(withRedux(ConfirmMetStatusModal))
